import { forwardRef, useState } from 'react';
import { Eye, EyeOff, Lock } from 'lucide-react';
import Input from '@/components/ui/Input';

type Props = React.InputHTMLAttributes<HTMLInputElement> & { label: string; error?: string; helperText?: string };

/** A password input with a show/hide button. */
const PasswordField = forwardRef<HTMLInputElement, Props>(({ label, error, helperText, ...props }, ref) => {
  const [shown, setShown] = useState(false);
  return (
    <Input
      ref={ref}
      label={label}
      type={shown ? 'text' : 'password'}
      leftIcon={<Lock className="h-4 w-4" />}
      rightIcon={
        <button
          type="button"
          className="text-muted-foreground transition-colors hover:text-foreground"
          onClick={() => setShown((s) => !s)}
          aria-label={shown ? 'Hide password' : 'Show password'}
        >
          {shown ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      }
      error={error}
      helperText={helperText}
      {...props}
    />
  );
});
PasswordField.displayName = 'PasswordField';
export default PasswordField;
